export const configTypes = {
  INTEGER: 'INTEGER',
  LIST: 'LIST',
  BOOLEAN: 'BOOLEAN',
  STRING: 'STRING'
}
